module.exports = __webpack_public_path__ + "static/media/bg7.4fa96003.jpeg";